import * as React from "react";
import { useLocation } from "react-router";

// The value used here is the last path segment in the URL
export enum SettingsTab {
  Organization = "organization",
  Tokens = "tokens",
  Usage = "usage",
  AI = "ai",
  Secrets = "secrets",
  Integrations = "integrations",
  CustomFields = "custom-fields",
}

function deriveActiveTabFromUrl(pathname: string) {
  // Extract the first segment after /settings/ (e.g. "ai" from "/settings/ai/register-mcp-server")
  const segments = pathname.replace(/^\/settings\/?/, "").split("/");
  const tab = segments[0];

  switch (tab as SettingsTab) {
    case SettingsTab.Tokens:
      return SettingsTab.Tokens;
    case SettingsTab.Usage:
      return SettingsTab.Usage;
    case SettingsTab.AI:
      return SettingsTab.AI;
    case SettingsTab.Secrets:
      return SettingsTab.Secrets;
    case SettingsTab.Integrations:
      return SettingsTab.Integrations;
    case SettingsTab.CustomFields:
      return SettingsTab.CustomFields;
    case SettingsTab.Organization:
      return SettingsTab.Organization;
    default:
      return SettingsTab.Organization;
  }
}

export function useActiveSettingsTab() {
  const location = useLocation();

  const [activeTab, setActiveTab] = React.useState(
    deriveActiveTabFromUrl(location.pathname),
  );

  React.useEffect(() => {
    setActiveTab(deriveActiveTabFromUrl(location.pathname));
  }, [location.pathname]);

  return [activeTab, setActiveTab] as const;
}
